
import { create } from "zustand";

interface FilterState {
    filters: Record<string, any>;
    totalRecords: number;
    setFilters: (filters: FilterState["filters"]) => void;
    setTotalRecords: (totalRecords: number) => void;
    resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
    query: { value: "", matchMode: "contains" },
    type: { value: "", matchMode: "contains" },
    employeeName: { value: "", matchMode: "contains" },
    status: { value: "", matchMode: "contains" },
    // date: { value: "", matchMode: "contains" },
    // createdAt: { value: "", matchMode: "contains" },
};

export const useFilterExpenseGridStore = create<FilterState>((set) => ({
    filters: defaultFilters,
    totalRecords: 0,
    setFilters: (filters) => set({ filters }),
    setTotalRecords: (totalRecords) => set({ totalRecords }),
    resetFilters: () => set({ filters: defaultFilters }),
}));
